import React, { Component } from 'react';
import './Experience.css';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
//import Markdown from 'react-remarkable';
import { Remarkable } from 'remarkable';
import RemarkableReactRenderer from 'remarkable-react';

/**
* @desc experience tab content candidate profile section
* @param props
* @return DOMElement
*/
const Experience = (props) => {  
  let startDateStr = ((props.dateStart && props.dateStart !== '' && props.dateStart !== "0000-00-00 00:00:00") ? moment(props.dateStart).format("MMMM YYYY") : '');
  let endDateStr = (props.current_role === "0") ? ((props.dateEnd && props.dateEnd !== '' && props.dateEnd !== "0000-00-00 00:00:00") ? ' - ' + moment(props.dateEnd).format("MMMM YYYY") : '') : " - To Present";

  // let startDateStr = ((props.dateStart && props.dateStart !== '' && props.dateStart !== "0000-00-00 00:00:00") ? props.dateStart : '');
  // let endDateStr = (props.current_role === "0") ? ((props.dateEnd && props.dateEnd !== '' && props.dateEnd !== "0000-00-00 00:00:00") ? ' - ' + props.dateEnd : '') : " - To Present";

  if(startDateStr === "" && endDateStr === "") {
    startDateStr = "Not Specified";
  }

  const md = new Remarkable();
  md.set({
    html: true,
    breaks: true
  });
  md.block.ruler.disable(['code']);
  md.renderer = new RemarkableReactRenderer();

  return (
    <div className="candidate-experience tab-body">
      <Row className="timeline">  
        <Col sm={5} xs={10} className="date-cont">
          <div className="date">{startDateStr} {endDateStr}</div>
        </Col>
        <div className="clearfix"></div>      
        <Col className="ex-det" xs={12} sm={12}>
          <h4 className="experience-expanded-h4">{props.title?props.title:"NA"} | <span>{props.company?props.company:"NA"}</span> </h4>
          <p>{md.render(props.description)}</p>
          <div className="line exp"></div>
        </Col>
      </Row>
    </div>
  );
}

export default Experience;



// WEBPACK FOOTER //
// ./src/components/Client/Experience/Experience.js